var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMsgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-msg-search_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161166",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31327",
  clipPath: "url(#icon-msg-search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38647",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161165",
  fill: "#fff",
  d: "M16.35 21.499h32.369v23.155H16.35z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38648",
  d: "M54.965 38.467a7.685 7.685 0 11-7.686-7.686 7.685 7.685 0 017.686 7.686",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38649",
  d: "M47.279 46.97a8.5 8.5 0 118.5-8.5 8.508 8.508 0 01-8.5 8.5zm0-15.371a6.872 6.872 0 106.873 6.873 6.88 6.88 0 00-6.873-6.878z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38650",
  d: "M43.622 39.28a.813.813 0 01-.813-.813 4.444 4.444 0 012.856-4.171.813.813 0 11.588 1.517 2.828 2.828 0 00-1.817 2.655.813.813 0 01-.814.812z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1443",
  d: "M55.136 49.721a.812.812 0 01-.646-.316l-3.287-4.255a.813.813 0 01.146-1.141.813.813 0 011.141.146l3.287 4.256a.813.813 0 01-.146 1.141.81.81 0 01-.495.169z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38651",
  d: "M37.346 45.639H17.512a2.621 2.621 0 01-2.618-2.619V22.657a2.621 2.621 0 012.618-2.619h29.4a2.622 2.622 0 012.619 2.619v4.321a.813.813 0 11-1.626 0v-4.321a.993.993 0 00-.992-.992h-29.4a.993.993 0 00-.992.992v20.364a.993.993 0 00.992.992h19.834a.813.813 0 010 1.626z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1444",
  d: "M16.75 44.745a.81.81 0 01-.521-.189.813.813 0 01-.1-1.145l7.454-8.926a.813.813 0 011.145-.1.813.813 0 01.1 1.145l-7.454 8.923a.812.812 0 01-.624.292z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38652",
  d: "M32.262 34.595a.812.812 0 01-.5-.17L15.853 22.142a.813.813 0 11.994-1.287l15.411 11.9 15.281-11.994a.813.813 0 011 1.279L32.764 34.422a.812.812 0 01-.502.173z",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-msg-search.c1a0a7f9492bf4a610ccbb8f9d3da05a.svg";
export { SvgIconMsgSearch as ReactComponent };